import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/* Restrict route to admin role only — staff users get redirected to /admin */
export default function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/admin" replace />;
  return children;
}
